// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"480":"1382d3b4","541":"1382d3b4"}[chunkId] + ".chunk.css";
};